<div class="main-screen-container">
    <div class="top-row">
        <button mat-flat-button color="accent" (click)="router.navigate(['/users-list'])"><img style="width:25px;"
                src="/assets/img/back.png" alt=""> Powrót na listę użytkowników</button>
    </div>

    <mat-card class="list-container">
        <mat-card-content>
            <div class="row">
                <div class="view-screen">
                    <h3>Przypisanie rekbotów do użytkownika {{ user.name + ' ' + user.surname}}</h3>
                </div>

            </div>
            <hr>
            <div class="d-flex flex-column" style="gap:20px;">

                <!-- div class="row">
                <div class="col-5">
                    <mat-form-field style="width:100%;">
                        <mat-label>Rekboty</mat-label>
                        <mat-select [(ngModel)]="userRekbots" multiple>
                            @for (rekbot of rekbotList; track rekbot) {
                            <mat-option [value]="rekbot.id">{{rekbot.serial_no}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-4">
                    <button mat-flat-button color="accent"
                        (click)="saveAssignedRekbots()">Przypisz zaznaczone rekboty</button>
                </div>
                <div *ngIf="0" class="col">
                    @for (selectedRekbot of userRekbots; track selectedRekbot) {
                    <div><span>{{ selectedRekbot.serial_no }}</span></div>
                    }
                </div>
            </div>

            <div *ngIf="isLoading">
                <mat-progress-bar mode="query"></mat-progress-bar>
            </div>
            <div style="height:4px;" *ngIf="!isLoading">
            </div -->

                <app-user-rekbot-list-small [selectedRekbotsIds]="userRekbots"
                    [userId]="user.id"></app-user-rekbot-list-small>

                <button mat-flat-button color="accent" (click)="saveAssignedRekbots()">Przypisz zaznaczone
                    rekboty</button>
            </div>
        </mat-card-content>
    </mat-card>

</div>